"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GymStatus;
(function (GymStatus) {
    GymStatus[GymStatus["INACTIVE"] = 0] = "INACTIVE";
    GymStatus[GymStatus["ACTIVE"] = 1] = "ACTIVE";
    GymStatus[GymStatus["CLOSING"] = 2] = "CLOSING";
    GymStatus[GymStatus["DELETED"] = 3] = "DELETED";
})(GymStatus = exports.GymStatus || (exports.GymStatus = {}));
(function (GymStatus) {
    function toString(status) {
        switch (status) {
            case GymStatus.DELETED:
                return "Deleted";
            case GymStatus.ACTIVE:
                return "Active";
            case GymStatus.CLOSING:
                return "Closing";
            case GymStatus.INACTIVE:
            default:
                return "Inactive";
        }
    }
    GymStatus.toString = toString;
})(GymStatus = exports.GymStatus || (exports.GymStatus = {}));
var CommonAddress;
(function (CommonAddress) {
    function toString(address) {
        return address.line + ", " + address.city + ", " + address.province + ", " + address.country;
    }
    CommonAddress.toString = toString;
})(CommonAddress = exports.CommonAddress || (exports.CommonAddress = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["PENDING"] = 0] = "PENDING";
    OrderStatus[OrderStatus["SHIPPING"] = 1] = "SHIPPING";
    OrderStatus[OrderStatus["DONE"] = 2] = "DONE";
    OrderStatus[OrderStatus["REJECTED"] = 3] = "REJECTED";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
(function (OrderStatus) {
    function toString(status) {
        switch (status) {
            case OrderStatus.DONE:
                return "Done";
            case OrderStatus.REJECTED:
                return "Rejected";
            case OrderStatus.SHIPPING:
                return "Shipping";
            case OrderStatus.PENDING:
            default:
                return "Pending";
        }
    }
    OrderStatus.toString = toString;
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
//# sourceMappingURL=entities.js.map